/**
 * 月の加算。
 * @note takezawa Date.setMonth()は1月31日+1ヶ月の場合、3月3日になってしまう（末日オーバーした際の月繰り上げ仕様がある）ので、それをせず日付を末日でリミットする月加算関数を作成した。
 * @param date 加算対象の日付
 * @param add_month 加算月数（ヶ月）
 * @returns add_month加算後の日付
 */
export function addMonthLimitLastDays(date :Date,add_month: number ) : Date
{
  let days = date.getDate();
  let month = date.getMonth() + add_month;
  let year = date.getFullYear();
  // 月が12月を超えた、１月下回った際の年加減算
  year = year + Math.floor(month / 12);
  month %= 12;
  if( month < 0 ) month = 12 + month;

  // 末日算出
  let last_date = new Date(year, month+1, 0);
  let last_days = last_date.getDate();

  // 日の末日リミット
  if( days > last_days ){
    days = last_days;
  }

  return new Date( year, month, days);
}

/**
 * dateの月の末日を返す。
 * @param date 
 */
export function calcLastDate( date :Date ) : Date
{
  let month = date.getMonth();
  let year = date.getFullYear();
  return new Date(year, month+1, 0);
}
